import {Expose} from "class-transformer";
import {CurrencyName} from "@models/v2/account/ModelAccountCurrency";

export default class ModelTransferCurrency {
	@Expose({name: "id"})
	private readonly _id: number;

	@Expose({name: "name"})
	private readonly _name: CurrencyName;

	@Expose({name: "abbr"})
	private readonly _abbr: string;

	constructor(id: number, name: CurrencyName, abbr: string) {
		this._id = id;
		this._name = name;
		this._abbr = abbr;
	}

	public get id() {
		return this._id;
	}

	public get name() {
		return this._name;
	}

	public get abbr() {
		return this._abbr;
	}
}
